import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addRecipeTypeApi, listOfRecipeTypesApi, updateRecipeTypeApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
export const RecipeTypes = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [recipeTypesData, setRecipeTypesData] = useState()
    const [editRecipeTypesData, setEditRecipeTypesData] = useState()
    const [loading, setLoading] = useState(false)

    // get the list of all available Recipe Types 
    //==============================
    const getListOfRecipeTypes = () => {
        setLoading(true)

        listOfRecipeTypesApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        getListOfRecipeTypes()
    }, []);


    // call when user click on edit
    //==============================
    const editRecipeType = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'recipe_types': data.name })
        setEditRecipeTypesData(data);
    }


    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterRecipeTypes(recipeTypesData);
    }, [recipeTypesData]);

    // filter recipe category
    const filterRecipeTypes = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    const columns = [
        {
            title: 'Recipe types',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editRecipeType(record) }} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Grains',
            status: true
        },
        {
            id: '2',
            name: 'Protein',
            status: false
        },
        {
            id: '3',
            name: 'Cooked Vegetables',
            status: true
        },
        {
            id: '4',
            name: 'Fruits',
            status: true
        },
        {
            id: '5',
            name: 'Soup',
            status: true
        },
    ];

    const [form] = Form.useForm();

    // handle submit event
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.recipe_types,
                "status": true
            }
            addRecipeTypeApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'recipe_types': '' })
                        notification.success({
                            message: "Recipe Type added successfully",
                        });
                        getListOfRecipeTypes()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.recipe_types,
                "status": values.status
            }
            updateRecipeTypeApi(editRecipeTypesData.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Recipe Type Update successfully",
                        });
                        getListOfRecipeTypes()
                        form.setFieldsValue({ 'recipe_types': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    // update status of recipe Types
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateRecipeTypeApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Recipe Type Update successfully",
                    });
                    getListOfRecipeTypes()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };
    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="RecipeTypes">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addRecipeTypesForm"
                        className="addRecipeTypes"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addRecipeTypesForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="recipe_types"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Recipe Types!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Recipe Types" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit"
                                    className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total Recipe Types:  {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Recipe Types"
                        onChange={(e) => { filterRecipeTypes(e.target.value); setRecipeTypesData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        dataSource={displayData}
                        rowKey="id"
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div >
    )
}
